import { render } from "./dol-date.vue?vue&type=template&id=173cb427"
import script from "./dol-date.vue?vue&type=script&lang=js"
export * from "./dol-date.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__